export enum GlobalRemoteEnum {
  JEZYK_TYP = 'JezykTyp'
}
